<div class="grid-1col input-grid-gaps dialog-width">
    @if (settingAlreadyExists()) {
        <app-error-float-message
            [message]="prefix + 'domainValidation.settingAlreadyExists'"
            [messageParams]="{ domain: domainDebounce() }"
        ></app-error-float-message>
    } @else if (settingWillInvalidateOthers()) {
        <app-warn-float-message
            [message]="prefix + 'domainValidation.settingWillInvalidateOthers'"
            [messageParams]="{ domain: domainDebounce() }"
        ></app-warn-float-message>
    } @else if (settingValidToAlreadyExists() !== null) {
        <app-error-float-message
            [message]="prefix + 'domainValidation.settingValidToAlreadyExists'"
            [messageParams]="{ domain: domainDebounce(), date: (settingValidToAlreadyExists() | localDate: 'd.M.y') }"
        ></app-error-float-message>
    } @else if (settingWillBeValidFrom() !== null) {
        <app-info-float-message
            [message]="prefix + 'domainValidation.settingWillBeValidFrom'"
            [messageParams]="{ domain: domainDebounce(), date: (settingWillBeValidFrom() | localDate: 'd.M.y') }"
        ></app-info-float-message>
    } @else if (enteredKeysDontWork()) {
        <app-error-float-message
            [message]="prefix + 'domainValidation.enteredKeysDontWork'"
        ></app-error-float-message>
    }

    <app-text-input
        [formField]="formDef.domain"
        [label]="prefix + 'fields.domainLabel'"
    ></app-text-input>

    <app-text-input
        [formField]="formDef.tenantId"
        [label]="prefix + 'fields.tenantId'"
    ></app-text-input>

    <app-text-input
        [formField]="formDef.clientId"
        [label]="prefix + 'fields.clientId'"
    ></app-text-input>

    <div>
        @if (!item || editClientSecret()) {
            <app-text-input
                [formField]="formDef.clientSecret"
                [label]="prefix + 'fields.clientSecret'"
            ></app-text-input>
        }
        @if (item) {
            <app-link-button
                [label]="prefix + (editClientSecret() ? 'disable' : 'enable') + 'EditClientSecret'"
                (clickEvent)="editClientSecret.set(!editClientSecret())"
            ></app-link-button>
        }
    </div>

    <app-date-input
        class="mt-3"
        [formField]="formDef.dateTo"
        [label]="prefix + 'fields.dateTo'"
        [showClear]="true"
    ></app-date-input>

    @if (formData().dateTo !== null) {
        <app-email-input
            [formField]="formDef.sendReminderToEmail"
            [label]="prefix + 'fields.sendReminderToEmail'"
        ></app-email-input>
    }
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons
        [primaryButtonLoading]="loading()"
        [primaryButtonDisability]="loading() || isAnyValidationError()"
        (primaryClickEvent)="save()"
        (secondaryClickEvent)="dialogRef.close()"
    ></app-action-buttons>
</div>
